<template>
	<div>
		<md-dialog :md-active="show" style="font-family: 'Montserrat', sans-serif; height: 250px; top: 30%">
			<div class="dialog" style="background-color: #eeeeee">
				<div class="dialog-header">
					<span style="margin-top: auto; margin-bottom: auto; font-size: 18px">{{ $t("new-area") }}</span>
					<div style="margin-left: auto; margin-right: 0px">
						<md-button @click="close" class="md-icon-button" style="margin-right: -5px">
							<md-icon style="color: white">close</md-icon>
						</md-button>
					</div>
				</div>
				<div class="dialog-body" style="width: 100%">
					<div class="form" style="top: 50%">
						<el-form label-width="100px" class="demo-ruleForm">
							<el-form-item :label="$t('name')">
								<strong slot="label">{{ $t("name") }}</strong>
								<el-input v-model="area" :placeholder="$t('name')" @keyup.native.enter="add"></el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<div class="dialog-footer">
					<div style="margin-left: auto; margin-right: 0px">
						<md-button class="cancel" @click="close">{{ $t("cancel") }}</md-button>
						<md-button class="add" @click="add">
							<i class="el-icon-loading" v-if="loading" />
							<span>{{ $t("add") }}</span>
						</md-button>
					</div>
				</div>
			</div>
		</md-dialog>
	</div>
</template>

<script>
export default {
	name: "areas-add",
	props: ["show"],
	data() {
		return {
			area: undefined,
			loading: false
		}
	},
	methods: {
		close: function () {
			this.area = ""
			this.$emit("close")
		},
		add: function () {
			this.$emit("add", this.area)
			this.area = undefined
			// this.$emit("close")
		}
	}
}
</script>
